module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/homeruns-wins-1-734f61e482344d514f94968f46264277.svg";